module.exports = __webpack_public_path__ + "img/updated.d1ed9bc8.png";